// extracted by mini-css-extract-plugin
export default {"gap":"Q_uUW"};